import React, { useState } from "react";
import { Tooltip, MenuItem, Box } from "@chakra-ui/react";
import { ChakraFAIcon } from "@/components/ui/Icon";

interface Props {
	icon: string;
	label: string;
	disabled?: boolean;
	dataTestId?: string;
	tooltip?: string;
	onClick?: () => void;
}

export function ActionsMenuItem(props: Props): JSX.Element {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<Tooltip label={props.tooltip} aria-label={props.tooltip} placement="left" openDelay={250} hasArrow isOpen={isHovered}>
			<Box onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
				<MenuItem
					icon={<ChakraFAIcon icon={props.icon} variant="solid" color="#6B778C" boxSize={4} />}
					onClick={props.onClick}
					isDisabled={props.disabled}
					data-testid={props.dataTestId}
				>
					{props.label}
				</MenuItem>
			</Box>
		</Tooltip>
	);
}
